/*contributing*/
/*discussions*/
/*acknowledgements*/
/*inspiration--prior-art*/
/*additional-thanks*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "社区",
  "description": "了解 Turborepo 社区。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 每周下载量超过 200 万次，在全球拥有庞大而活跃的开发者社区。以下是你可以参与的方式。"
  }, {
    "heading": "",
    "content": "¥With over 2 million weekly downloads, Turborepo has a large and active community of developers across the world. Here's how you can get involved."
  }, {
    "heading": "贡献-contributing",
    "content": "¥Contributing"
  }, {
    "heading": "贡献-contributing",
    "content": "文档：建议改进，甚至编写新的章节，以帮助理解如何使用 Turborepo。"
  }, {
    "heading": "贡献-contributing",
    "content": "¥Documentation: Suggest improvements or even write new sections to help build understanding of how to use Turborepo."
  }, {
    "heading": "贡献-contributing",
    "content": "示例：通过改进示例，帮助开发者将 Turborepo 与其他工具和服务集成。"
  }, {
    "heading": "贡献-contributing",
    "content": "¥Examples: Help developers integrate Turborepo with other tools and services by improving an example."
  }, {
    "heading": "贡献-contributing",
    "content": "代码：了解有关底层架构的更多信息，贡献错误修复并建议新功能。"
  }, {
    "heading": "贡献-contributing",
    "content": "¥Code: Learn more about the underlying architecture, contribute bug fixes, and suggest new features."
  }, {
    "heading": "讨论-discussions",
    "content": "¥Discussions"
  }, {
    "heading": "讨论-discussions",
    "content": "如果你对 Turborepo 有任何疑问或想帮助他人，请加入讨论："
  }, {
    "heading": "讨论-discussions",
    "content": "¥If you have a question about Turborepo or want to help others, join the conversation:"
  }, {
    "heading": "讨论-discussions",
    "content": "GitHub 讨论"
  }, {
    "heading": "讨论-discussions",
    "content": "¥GitHub Discussions"
  }, {
    "heading": "讨论-discussions",
    "content": "Vercel 社区"
  }, {
    "heading": "讨论-discussions",
    "content": "¥Vercel Community"
  }, {
    "heading": "致谢-acknowledgements",
    "content": "¥Acknowledgements"
  }, {
    "heading": "致谢-acknowledgements",
    "content": "Turborepo 最初由 Jared Palmer 创建，是一款闭源企业软件产品。2021 年末，Vercel 收购 Turborepo 开源了代码库。"
  }, {
    "heading": "致谢-acknowledgements",
    "content": "¥Turborepo was originally created by Jared Palmer as a closed-source enterprise software offering. In late 2021, Vercel acquired Turborepo and open sourced the codebase."
  }, {
    "heading": "致谢-acknowledgements",
    "content": "如今，Turborepo 拥有一支全职团队致力于此，并且其 开源贡献者 列表也在不断增加。"
  }, {
    "heading": "致谢-acknowledgements",
    "content": "¥Today, Turborepo has dedicated full-time team working on it as well as a growing list of open source contributors."
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥Inspiration / Prior Art"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "在 Vercel，我们深信开源运动和开放协作的力量。为此，对激励我们和我们工作的项目和人员进行有意义的归因至关重要。"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥At Vercel, we believe deeply in the open source movement and in the power of open collaboration. To that end, it's important to provide meaningful attribution to the projects and people that inspire(d) us and our work."
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "我们想特别感谢其他构建系统、monorepo 工具和现有技术："
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥We'd like to make a special shoutout to other build systems, monorepo tools, and prior art:"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Bazel - https://bazel.build"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Buck - https://buck.build"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "请 - https://please.build"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥Please - https://please.build"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Pants - https://www.pantsbuild.org"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Scoot - https://github.com/twitter/scoot"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "TSDX - https://tsdx.io"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Lerna - https://lerna.nodejs.cn"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Lage - https://microsoft.github.io/lage"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "回填 - https://github.com/microsoft/backfill"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥Backfill - https://github.com/microsoft/backfill"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Bolt - https://github.com/boltpkg/bolt"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Rush - https://rushjs.io"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "预构建 - https://preconstruct.tools"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "¥Preconstruct - https://preconstruct.tools"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Nx - https://nx.dev"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "Yarn - https://yarn.nodejs.cn"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "npm - https://www.npmjs.com"
  }, {
    "heading": "灵感现有技术-inspiration--prior-art",
    "content": "pnpm - https://pnpm.nodejs.cn"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Additional Thanks"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "此外，我们感谢："
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Additionally, we're grateful to:"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Rick Button 感谢在 npm 上捐赠 turbo 软件包名称"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Rick Button for donating the turbo package name on npm"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Iheanyi Ekechukwu 感谢在疫情期间帮助 Jared 学习 Golang！"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Iheanyi Ekechukwu for helping Jared pick up Golang during the Pandemic!"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "Kenneth Chau 感谢 Lage 的作用域和管道 API 及文档"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Kenneth Chau for Lage's Scope and Pipeline API and docs"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "用于试用 Turborepo 的 Miguel Oller 和 MakeSwift.com"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Miguel Oller and MakeSwift.com for piloting Turborepo"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "用于 Turborepo 试用的 Eric Koslow、Jack Hanford 和 Lattice.com"
  }, {
    "heading": "致谢-additional-thanks",
    "content": "¥Eric Koslow, Jack Hanford, and Lattice.com for piloting Turborepo"
  }],
  "headings": [{
    "id": "贡献-contributing",
    "content": "贡献 /*contributing*/"
  }, {
    "id": "讨论-discussions",
    "content": "讨论 /*discussions*/"
  }, {
    "id": "致谢-acknowledgements",
    "content": "致谢 /*acknowledgements*/"
  }, {
    "id": "灵感现有技术-inspiration--prior-art",
    "content": "灵感/现有技术 /*inspiration--prior-art*/"
  }, {
    "id": "致谢-additional-thanks",
    "content": "致谢 /*additional-thanks*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#贡献-contributing",
  title: _jsx(_Fragment, {
    children: "贡献 "
  })
}, {
  depth: 2,
  url: "#讨论-discussions",
  title: _jsx(_Fragment, {
    children: "讨论 "
  })
}, {
  depth: 2,
  url: "#致谢-acknowledgements",
  title: _jsx(_Fragment, {
    children: "致谢 "
  })
}, {
  depth: 3,
  url: "#灵感现有技术-inspiration--prior-art",
  title: _jsx(_Fragment, {
    children: "灵感/现有技术 "
  })
}, {
  depth: 3,
  url: "#致谢-additional-thanks",
  title: _jsx(_Fragment, {
    children: "致谢 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo 每周下载量超过 200 万次，在全球拥有庞大而活跃的开发者社区。以下是你可以参与的方式。"
    }), "\n", _jsx(_components.p, {
      children: "¥With over 2 million weekly downloads, Turborepo has a large and active community of developers across the world. Here's how you can get involved."
    }), "\n", _jsx(_components.h2, {
      id: "贡献-contributing",
      children: "贡献 "
    }), "\n", _jsx(_components.p, {
      children: "¥Contributing"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/tree/main/docs",
            children: "文档"
          }), "：建议改进，甚至编写新的章节，以帮助理解如何使用 Turborepo。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/tree/main/docs",
            children: "Documentation"
          }), ": Suggest improvements or even write new sections to help build understanding of how to use Turborepo."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/tree/main/examples",
            children: "示例"
          }), "：通过改进示例，帮助开发者将 Turborepo 与其他工具和服务集成。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/tree/main/examples",
            children: "Examples"
          }), ": Help developers integrate Turborepo with other tools and services by improving an example."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/blob/main/CONTRIBUTING.md",
            children: "代码"
          }), "：了解有关底层架构的更多信息，贡献错误修复并建议新功能。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/blob/main/CONTRIBUTING.md",
            children: "Code"
          }), ": Learn more about the underlying architecture, contribute bug fixes, and suggest new features."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "讨论-discussions",
      children: "讨论 "
    }), "\n", _jsx(_components.p, {
      children: "¥Discussions"
    }), "\n", _jsx(_components.p, {
      children: "如果你对 Turborepo 有任何疑问或想帮助他人，请加入讨论："
    }), "\n", _jsx(_components.p, {
      children: "¥If you have a question about Turborepo or want to help others, join the conversation:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/discussions",
            children: "GitHub 讨论"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/vercel/turborepo/discussions",
            children: "GitHub Discussions"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://community.vercel.com/tag/turborepo",
            children: "Vercel 社区"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://community.vercel.com/tag/turborepo",
            children: "Vercel Community"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "致谢-acknowledgements",
      children: "致谢 "
    }), "\n", _jsx(_components.p, {
      children: "¥Acknowledgements"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 最初由 ", _jsx(_components.a, {
        href: "https://x.com/jaredpalmer",
        children: "Jared Palmer"
      }), " 创建，是一款闭源企业软件产品。2021 年末，", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "Vercel 收购 Turborepo"
      }), " 开源了代码库。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo was originally created by ", _jsx(_components.a, {
        href: "https://x.com/jaredpalmer",
        children: "Jared Palmer"
      }), " as a closed-source enterprise software offering. In late 2021, ", _jsx(_components.a, {
        href: "https://vercel.com/blog/vercel-acquires-turborepo",
        children: "Vercel acquired Turborepo"
      }), " and open sourced the codebase."]
    }), "\n", _jsxs(_components.p, {
      children: ["如今，Turborepo 拥有一支全职团队致力于此，并且其 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/graphs/contributors",
        children: "开源贡献者"
      }), " 列表也在不断增加。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Today, Turborepo has dedicated full-time team working on it as well as a growing list of ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/graphs/contributors",
        children: "open source contributors"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "灵感现有技术-inspiration--prior-art",
      children: "灵感/现有技术 "
    }), "\n", _jsx(_components.p, {
      children: "¥Inspiration / Prior Art"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "，我们深信开源运动和开放协作的力量。为此，对激励我们和我们工作的项目和人员进行有意义的归因至关重要。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥At ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), ", we believe deeply in the open source movement and in the power of open collaboration. To that end, it's important to provide meaningful attribution to the projects and people that inspire(d) us and our work."]
    }), "\n", _jsx(_components.p, {
      children: "我们想特别感谢其他构建系统、monorepo 工具和现有技术："
    }), "\n", _jsx(_components.p, {
      children: "¥We'd like to make a special shoutout to other build systems, monorepo tools, and prior art:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bazel - ", _jsx(_components.a, {
            href: "https://bazel.build",
            children: "https://bazel.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Buck - ", _jsx(_components.a, {
            href: "https://buck.build",
            children: "https://buck.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["请 - ", _jsx(_components.a, {
            href: "https://please.build",
            children: "https://please.build"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Please - ", _jsx(_components.a, {
            href: "https://please.build",
            children: "https://please.build"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Pants - ", _jsx(_components.a, {
            href: "https://www.pantsbuild.org",
            children: "https://www.pantsbuild.org"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Scoot - ", _jsx(_components.a, {
            href: "https://github.com/twitter/scoot",
            children: "https://github.com/twitter/scoot"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["TSDX - ", _jsx(_components.a, {
            href: "https://tsdx.io",
            children: "https://tsdx.io"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Lerna - ", _jsx(_components.a, {
            href: "https://lerna.nodejs.cn",
            children: "https://lerna.nodejs.cn"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Lage - ", _jsx(_components.a, {
            href: "https://microsoft.github.io/lage",
            children: "https://microsoft.github.io/lage"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["回填 - ", _jsx(_components.a, {
            href: "https://github.com/microsoft/backfill",
            children: "https://github.com/microsoft/backfill"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Backfill - ", _jsx(_components.a, {
            href: "https://github.com/microsoft/backfill",
            children: "https://github.com/microsoft/backfill"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Bolt - ", _jsx(_components.a, {
            href: "https://github.com/boltpkg/bolt",
            children: "https://github.com/boltpkg/bolt"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Rush - ", _jsx(_components.a, {
            href: "https://rushjs.io",
            children: "https://rushjs.io"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["预构建 - ", _jsx(_components.a, {
            href: "https://preconstruct.tools",
            children: "https://preconstruct.tools"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Preconstruct - ", _jsx(_components.a, {
            href: "https://preconstruct.tools",
            children: "https://preconstruct.tools"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Nx - ", _jsx(_components.a, {
            href: "https://nx.dev",
            children: "https://nx.dev"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Yarn - ", _jsx(_components.a, {
            href: "https://yarn.nodejs.cn",
            children: "https://yarn.nodejs.cn"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["npm - ", _jsx(_components.a, {
            href: "https://www.npmjs.com",
            children: "https://www.npmjs.com"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["pnpm - ", _jsx(_components.a, {
            href: "https://pnpm.nodejs.cn",
            children: "https://pnpm.nodejs.cn"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "致谢-additional-thanks",
      children: "致谢 "
    }), "\n", _jsx(_components.p, {
      children: "¥Additional Thanks"
    }), "\n", _jsx(_components.p, {
      children: "此外，我们感谢："
    }), "\n", _jsx(_components.p, {
      children: "¥Additionally, we're grateful to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/rickbutton",
            children: "Rick Button"
          }), " 感谢在 npm 上捐赠 ", _jsx(_components.code, {
            children: "turbo"
          }), " 软件包名称"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/rickbutton",
            children: "Rick Button"
          }), " for donating the ", _jsx(_components.code, {
            children: "turbo"
          }), " package name on npm"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/kwuchu",
            children: "Iheanyi Ekechukwu"
          }), " 感谢在疫情期间帮助 Jared 学习 Golang！"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/kwuchu",
            children: "Iheanyi Ekechukwu"
          }), " for helping Jared pick up Golang during the Pandemic!"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://x.com/kenneth_chau",
            children: "Kenneth Chau"
          }), " 感谢 Lage 的作用域和管道 API 及文档"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/kenneth_chau",
            children: "Kenneth Chau"
          }), " for Lage's Scope and Pipeline API and docs"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["用于试用 Turborepo 的 ", _jsx(_components.a, {
            href: "https://mobile.x.com/ollermi",
            children: "Miguel Oller"
          }), " 和 ", _jsx(_components.a, {
            href: "https://www.makeswift.com/",
            children: "MakeSwift.com"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://mobile.x.com/ollermi",
            children: "Miguel Oller"
          }), " and ", _jsx(_components.a, {
            href: "https://www.makeswift.com/",
            children: "MakeSwift.com"
          }), " for piloting Turborepo"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["用于 Turborepo 试用的 ", _jsx(_components.a, {
            href: "https://x.com/ekosz1",
            children: "Eric Koslow"
          }), "、", _jsx(_components.a, {
            href: "https://x.com/jackhanford",
            children: "Jack Hanford"
          }), " 和 ", _jsx(_components.a, {
            href: "https://lattice.com/",
            children: "Lattice.com"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://x.com/ekosz1",
            children: "Eric Koslow"
          }), ", ", _jsx(_components.a, {
            href: "https://x.com/jackhanford",
            children: "Jack Hanford"
          }), ", and ", _jsx(_components.a, {
            href: "https://lattice.com/",
            children: "Lattice.com"
          }), " for piloting Turborepo"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
